import { Center, VStack, Box, Spinner, Flex } from "@reverb-ui/react";
import { makeReportsDatasource } from "../main/factories/datasources/reports-datasource-factory";
import {
  ReportsFilterContext,
  ReportsFilterProvider,
} from "../presentation/containers/context-api/ReportsFilterProvider";
import { makeReportsFiltersDatasource } from "../main/factories/datasources/reports-filters-repository";
import { SegmentProvider } from "../presentation/containers/context-api/SegmentProvider";
import { makeReportsSegmentDatasource } from "main/factories/datasources/reports-segment-repository";
import {
  TrafficInsightsProvider,
  TrafficSourceSummaryProvider,
} from "presentation/containers/context-api";
import { TrafficInsightsReports } from "presentation/containers/TrafficInsights";
import { InsightsOnTagsProvider } from "presentation/containers/context-api/InsightsOnTagsProvider";
import { InsightsOnTags } from "presentation/containers/InsightsOnTags";
import { PageSummaryProvider } from "presentation/containers/context-api/PageSummaryProvider";
import { PageSummaryReports } from "presentation/containers/PageSummary";
import { TrafficSourceSummaryReports } from "presentation/containers/TrafficSourceSummary";
import { ViewPortRankingProvider } from "presentation/containers/context-api/ViewPortRankingProvider";
import { ViewPortRankingReports } from "presentation/containers/ViewportRanking";
import VisitorsFunnelReports from "presentation/containers/VisitorsFunnel";
import { VisitorsFunnelProvider } from "presentation/containers/context-api/VisitorsFunnelProvider";
import "../styles/print-style.css";

export type FilterProps = {
  idPortfolio?: number;
  idCampaign?: number;
  idCreative?: number;
  idUrl?: number;
  startDate?: Date;
  endDate?: Date;
  idRange?: number;
};

export const SummaryReports = () => (
  <SegmentProvider reportsSegmentDatasource={makeReportsSegmentDatasource()}>
    <Center display="flex" flexDirection="column">
      <Box maxW="7xl" w="full">
        <ReportsFilterProvider
          reportsFiltersDatasource={makeReportsFiltersDatasource()}
        >
          <ReportsFilterContext.Consumer>
            {({ defaultFiltersLoading, loadingOptions }) =>
              defaultFiltersLoading ? (
                loadingOptions && (
                  <Flex justifyContent="center">
                    <Spinner size="xl" color="blue.500" />
                  </Flex>
                )
              ) : (
                <VStack spacing={5} w="full">
                  <VisitorsFunnelProvider
                    reportsDatasource={makeReportsDatasource()}
                    requestParamsIndex={0}
                  >
                    <VisitorsFunnelReports />
                  </VisitorsFunnelProvider>
                  <TrafficInsightsProvider
                    reportsDatasource={makeReportsDatasource()}
                    showCards={false}
                    mapProps={{ zoom: 1.3, minZoom: 1.3 }}
                    chartProps={{ paddingRight: 120 }}
                    requestParamsIndex={0}
                  >
                    <TrafficInsightsReports />
                  </TrafficInsightsProvider>
                  <InsightsOnTagsProvider
                    reportsDatasource={makeReportsDatasource()}
                    showCards={false}
                    requestParamsIndex={0}
                  >
                    <InsightsOnTags />
                  </InsightsOnTagsProvider>
                  <PageSummaryProvider
                    reportsDatasource={makeReportsDatasource()}
                    showCards={false}
                    requestParamsIndex={0}
                  >
                    <PageSummaryReports />
                  </PageSummaryProvider>
                  <TrafficSourceSummaryProvider
                    reportsDatasource={makeReportsDatasource()}
                    showCards={false}
                    requestParamsIndex={0}
                  >
                    <TrafficSourceSummaryReports />
                  </TrafficSourceSummaryProvider>
                  <ViewPortRankingProvider
                    reportsDatasource={makeReportsDatasource()}
                    showCards={false}
                    requestParamsIndex={0}
                  >
                    <ViewPortRankingReports />
                  </ViewPortRankingProvider>
                </VStack>
              )
            }
          </ReportsFilterContext.Consumer>
        </ReportsFilterProvider>
      </Box>
    </Center>
  </SegmentProvider>
);

export default SummaryReports;
